import { httpClient } from "./http-client";

export default httpClient;
